import {register} from '@shopify/theme-sections'
import $ from 'jquery'
import 'slick-carousel'
import '../../styles/components/carousel.scss'
import '../../styles/sections/index-hero-slider.scss'

export default register(`index-hero-slider`, {
  onLoad() {
    let slides = $(this.container).find(`.hero-slider-element`)

    if (slides.find(`.container-wrapper`).length > 1) {
      slides.slick({
        dots: true,
        arrows: true,
        mobileFirst: true,
        autoplaySpeed: 10000,
        autoplay: true,
        infinite: false,
        adaptiveHeight: true
      })
    }
  },

  /**
   * Event callback for Theme Editor `section:unload` event
   */
  onUnload() {
    $(`.hero-slider-element`).each(function() {
      $(this).unslick()
    })
  },
})

